customElements.define('search-modal', class SearchModal extends HTMLElement {
    constructor(){
        console.log("Construcion")
        super();
        this.elements = {
            togglers: document.querySelectorAll('.js-toggle-search'),
            close: this.querySelector('.js-close-search-modal'),
            fadeInItems: this.querySelectorAll('.fade-in-up')
        }
        console.log(document, this.elements.close)
        this.elements.togglers.forEach(toggler=>toggler.addEventListener("click", this.open.bind(this)))
        this.elements.close.addEventListener("click", this.close.bind(this))
    }

    open(event){
        //Open 
        window.innerWidth < 990 ? this.openMobile() : this.classList.add('active')
        window.innerWidth < 990 ? document.body.classList.add("overflow-hidden-tablet") : document.body.classList.add("overflow-hidden")
    }
    
    close(event){
        this.elements.fadeInItems.forEach(item=>{
            item.classList.remove("faded")
        })

        if(window.innerWidth < 990){
            setTimeout(()=>{
                this.classList.remove('active')
            }, 500)
        }else{
            this.classList.remove('active')
        }
        window.innerWidth < 990 ? document.body.classList.remove("overflow-hidden-tablet") : document.body.classList.remove("overflow-hidden")

    }

    openMobile(){
        //Open mobile with animations
        this.classList.add('active')
        setTimeout(()=>{
            this.elements.fadeInItems.forEach(item=>{
                item.classList.add("faded")
            })
        }, 800)
    }
})
